import { BulkProjectEditChangeReason } from "@app/projects/edit/bulkProjectEditChangeReason";
import { Fields } from "@app/projects/create/interfaces";

export default function DisableUnsupportedBulkEditOptions<T>(options: Fields<T>[]): Fields<T>[] {
  return options.map(field => {
    if (!Object.entries(BulkProjectEditChangeReason).find(([, reason]) => reason === field.key) && !field.disabled) {
      return {
        ...field,
        disabled: true,
        tooltip: "This option is not supported for bulk project edit changes."
      };
    }
    return field;
  });
}